import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as global from './global.service';
import { InjectorInstance } from '../app.module';
import { AuthenticationService } from './authentication.service';

@Injectable({providedIn: 'root'})
export class ApicallsService {

  public static uploadFile(file) {
    const httpClient = InjectorInstance.get<HttpClient>(HttpClient);
    const authenticationService = InjectorInstance.get<AuthenticationService>(AuthenticationService);
    const currentUser = authenticationService.currentUserValue;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + currentUser.access_token
    });

    return httpClient.post( global.API_URL + '/api/uploads/uploadimage', file, {
      headers: headers,
    });
  }

  constructor(public http: HttpClient) {

  }

  getAllRoles() {
    return this.http.get(global.API_URL + '/api/roles');
  }

  newRol(rol) {
    return this.http.post( global.API_URL + '/api/roles/create', rol);
  }

  getRol(id) {
    return this.http.get(global.API_URL + '/api/roles/view/' + id);
  }

  editRol(rol, id) {
    return this.http.post( global.API_URL + '/api/roles/update/' + id, rol);
  }
 

  deleteRol(id) {
    return this.http.delete(global.API_URL + '/api/roles/delete/' + id);
  }

  getAllUsers() {
    return this.http.get(global.API_URL + '/api/users');
  }

  newUser(user) {
    return this.http.post( global.API_URL + '/api/users/register', user);
  }
  newUserLite(user) {
    return this.http.post( global.API_URL + '/api/users/newregisterLite', user);
  }
  newUserStaff(user) {
    return this.http.post( global.API_URL + '/api/users/registerstaff', user);
  }
  deleteUserStaff(user) {
    return this.http.get( global.API_URL + '/api/users/deletestaff/' + user);
  }
  editUser(user, id) {
    return this.http.post( global.API_URL + '/api/users/update/' + id, user);
  }
  updateNew(user, id){
    return this.http.post( global.API_URL + '/api/users/updatenew/' + id, user);
  }

  changePassword(user, id) {
    return this.http.post( global.API_URL + '/api/users/password/' + id, user);
  }

  changePasswordPanel(user, key) {
    return this.http.post( global.API_URL + '/api/users/passwordpanel/' + key, user);
  }

  updateRolSelected(data) {
    return this.http.post( global.API_URL + '/api/users/updaterolselected', data);
  }

  forgotPassword(email) {
    return this.http.post(global.API_URL + '/api/users/forgotpasswordpanel', email);
}

  deleteUser(id) {
    return this.http.delete(global.API_URL + '/api/users/delete/' + id);
  }

  getUser(id) {
    return this.http.get(global.API_URL + '/api/users/view/' + id);
  }

  findUsers(obj) {
    return this.http.post( global.API_URL + '/api/users/find', obj);
  }

  stepWizard(id, step) {
    const data: any = {};
    data.step = step;
    return this.http.post(global.API_URL + '/api/users/step_wizard/' + id, data);
  }

  endWizard(id) {
    return this.http.get(global.API_URL + '/api/users/end_wizard/' + id);
  }
  getUserByEmail(email) {
    return this.http.post(global.API_URL + '/api/users/email', email);
  }

  searchLocals(search, ruta) {
    const obj: any = {};
    obj.term = search;
    obj.ruta = ruta;
    return this.http.post( global.API_URL + '/api/locals/panelsearch', obj);
  }

  getAllLocals() {
    return this.http.get(global.API_URL + '/api/locals');
  }

  getAllLocalsByRoute(id) {
    return this.http.get(global.API_URL + '/api/locals/route/' + id);
  }

  getAllLocalsByRouteCustomer(id, customerid) {
    return this.http.get(global.API_URL + '/api/locals/route/' + id + '/customer/' + customerid);
  }

  searchLocalsLite(search: any) {
    return this.http.post(global.API_URL + '/api/locals/searchLite', search);
  }

  getMeLocals(user) {
    return this.http.get(global.API_URL + '/api/locals/me/' + user);
  }

  newLocal(local) {
    return this.http.post( global.API_URL + '/api/locals/create', local);
  }

  getLocal(id) {
    return this.http.get(global.API_URL + '/api/locals/view/' + id);
  }

  editLocal(local, id) {
    return this.http.post( global.API_URL + '/api/locals/update/' + id, local);
  }

  changeActiveLocal(data, id) {
    return this.http.post( global.API_URL + '/api/locals/changeactive/' + id, data);
  }

  editLocals(locals) {
    return this.http.post( global.API_URL + '/api/locals/updateselected', locals);
  }

  deleteLocals(locals) {
    return this.http.post(global.API_URL + '/api/locals/deleteselected', locals);
  }

  deleteLocalFromRoute(local, route) {
    return this.http.delete(global.API_URL + '/api/locals/delete/' + local + '/fromroute/' + route);
  }

  addLocalToRoute(id, ruta) {
    const obj: any = {};
    obj.local = id;
    obj.ruta = ruta;
    return this.http.post( global.API_URL + '/api/locals/addlocal', obj);
  }

  getAllZones() {
    return this.http.get(global.API_URL + '/api/localszone');
  }

  getAllZonesByLocal(local: any) {
    return this.http.get(global.API_URL + '/api/localszone/bylocal/' + local);
  }

  newLocalZone(zone) {
    return this.http.post( global.API_URL + '/api/localszone/create', zone);
  }

  getLocalZone(id) {
    return this.http.get(global.API_URL + '/api/localszone/view/' + id);
  }

  editLocalZone(zone, id) {
    return this.http.post( global.API_URL + '/api/localszone/update/' + id, zone);
  }

  deleteLocalZone(id) {
    return this.http.delete(global.API_URL + '/api/localszone/delete/' + id);
  }

  getAllSubZonesByZone(zone: any) {
    return this.http.get(global.API_URL + '/api/localssubzone/byzone/' + zone);
  }

  newZoneSubzone(subzone) {
    return this.http.post( global.API_URL + '/api/localssubzone/create', subzone);
  }

  getZoneSubZone(id) {
    return this.http.get(global.API_URL + '/api/localssubzone/view/' + id);
  }

  editZoneSubzone(subzone, id) {
    return this.http.post( global.API_URL + '/api/localssubzone/update/' + id, subzone);
  }

  deleteZoneSubzone(id) {
    return this.http.delete(global.API_URL + '/api/localssubzone/delete/' + id);
  }


  addCartaLocal(cartainfo, id) {
    return this.http.post( global.API_URL + '/api/locals/addcarta/' + id, cartainfo);
  }

  copiarCarta(localcopy, id) {
    return this.http.post( global.API_URL + '/api/locals/copiarcarta/' + id, localcopy);
  }

  deleteLocal(id) {
    return this.http.delete(global.API_URL + '/api/locals/delete/' + id);
  }

  getAllRoutersByLocal(local_id) {
    return this.http.get(global.API_URL + '/api/routers/bylocal/' + local_id);
  }

  newRouterLocal(router) {
    return this.http.post( global.API_URL + '/api/routers/create', router);
  }

  getRouterLocal(id) {
    return this.http.get(global.API_URL + '/api/routers/view/' + id);
  }

  editRouterLocal(local, id) {
    return this.http.post( global.API_URL + '/api/routers/update/' + id, local);
  }

  deleteRouterLocal(id) {
    return this.http.delete(global.API_URL + '/api/routers/delete/' + id);
  }

  getAllPushByLocal(local_id) {
    return this.http.get(global.API_URL + '/api/localspush/bylocal/' + local_id);
  }

  newPushLocal(push) {
    return this.http.post( global.API_URL + '/api/localspush/create', push);
  }

  getPushLocal(id) {
    return this.http.get(global.API_URL + '/api/localspush/view/' + id);
  }

  editPushLocal(push, id) {
    return this.http.post( global.API_URL + '/api/localspush/update/' + id, push);
  }

  deletePushLocal(id) {
    return this.http.delete(global.API_URL + '/api/localspush/delete/' + id);
  }

  sendCsvPush(id, data) {
    return this.http.post( global.API_URL + '/api/localspush/csv/' + id, data);
  }

  deleteCsvPush(id) {
    return this.http.post( global.API_URL + '/api/localspush/deletecsv/' + id, {});
  }

  getAllPromos(type) {
    return this.http.get(global.API_URL + '/api/promos/' + type);
  }

  getAllPromosByUser(type, user) {
    const data: any = {};
    data.user = user;
    return this.http.post(global.API_URL + '/api/promos/byuser/' + type, data);
  }

  getAllPromosByLocal(local) {
    return this.http.get(global.API_URL + '/api/promos/bylocal/' + local);
  }

  changeActivePromo(data, id) {
    return this.http.post( global.API_URL + '/api/promos/changeactive/' + id, data);
  }

  newPromo(promo) {
    return this.http.post( global.API_URL + '/api/promos/create', promo);
  }

  getPromo(id) {
    return this.http.get(global.API_URL + '/api/promos/view/' + id);
  }

  editPromo(promo, id) {
    return this.http.post( global.API_URL + '/api/promos/update/' + id, promo);
  }

  updatePromoLocal(promo, local) {
    
    
    return this.http.get( global.API_URL + '/api/promos/updatelocal/' + promo + '/local/' + local);
  }

  deletePromo(id) {
    return this.http.delete(global.API_URL + '/api/promos/delete/' + id);
  }

  deletePromos(promos) {
    return this.http.post(global.API_URL + '/api/promos/deleteselected', promos);
  }

  sendCsvPromo(id, data) {
    return this.http.post( global.API_URL + '/api/promos/csv/' + id, data);
  }

  deleteCsvPromo(id) {
    return this.http.post( global.API_URL + '/api/promos/deletecsv/' + id, {});
  }

  addPreferencesToPromo(ids, idPromo, all) {
    const data: any = {};
    data.ids = ids;
    data.all = all;
    return this.http.post(global.API_URL + '/api/promos/addpreferencia/' + idPromo, data);
  }

  deletePreferencesToPromo(id, idPromo) {
    const data: any = {};
    data.idpreferencia = id;
    return this.http.post(global.API_URL + '/api/promos/deletepreferencia/' + idPromo, data);
  }

  addLocalsToPromo(ids, idPromo) {
    const data: any = {};
    data.ids = ids;
    return this.http.post(global.API_URL + '/api/promos/addlocal/' + idPromo, data);
  }

  deleteLocalToPromo(id, idPromo) {
    const data: any = {};
    data.idlocal = id;
    return this.http.post(global.API_URL + '/api/promos/deletelocal/' + idPromo, data);
  }

  getAllCustomers() {
    return this.http.get(global.API_URL + '/api/customers');
  }

  findCustomers(obj) {
    return this.http.post( global.API_URL + '/api/customers/find', obj);
  }

  searchCustomers(search, searchlocal) {
    const obj: any = {};
    obj.term = search;
    obj.local = searchlocal;
    return this.http.post( global.API_URL + '/api/customers/search', obj);
  }
 
  newCustomers(customers) {
    return this.http.post( global.API_URL + '/api/customers/create', customers);
  }

  getCustomerByUser(id) {
    return this.http.get(global.API_URL + '/api/customers/user/' + id);
  }

  getCustomerByStaff(id) {
    return this.http.get(global.API_URL + '/api/customers/user_staff/' + id);
  }

  addStaffsUser(data) {
    return this.http.post(global.API_URL + '/api/staffs/add', data);
  }

  createStaffUser(data) {
    return this.http.post(global.API_URL + '/api/staffs/createuser', data);
  }

  deleteStaffsUser(field) {
    return this.http.post(global.API_URL + '/api/staffs/remove', field);
  }

  deleteStaffsUserSelected(field) {
    return this.http.post(global.API_URL + '/api/staffs/removeselected', field);
  }

  getUsersStaffsByLocal(id) {
    return this.http.get(global.API_URL + '/api/locals/users/' + id);
  }

  getUsersStaffsByClient(id) {
    return this.http.get(global.API_URL + '/api/customers/users/' + id);
  }

  getCustomers(id) {
    return this.http.get(global.API_URL + '/api/customers/view/' + id);
  }

  editCustomers(customers, id) {
    return this.http.post( global.API_URL + '/api/customers/update/' + id, customers);
  }

  editCustomersWizard(customers, id) {
    return this.http.post( global.API_URL + '/api/customers/update_wizard/' + id, customers);
  }

  createUserCustomers(password, id) {
    const data: any = {};
    data.password = password;
    return this.http.post( global.API_URL + '/api/customers/createuser/' + id, data);
  }

  deleteCustomers(id) {
    return this.http.delete(global.API_URL + '/api/customers/delete/' + id);
  }

  // 
  getAllGroupsCustomers() {
    return this.http.get(global.API_URL + '/api/groupscustomers');
  }

  newGroupsCustomers(customers) {
    return this.http.post( global.API_URL + '/api/groupscustomers/create', customers);
  }

  getGroupsCustomers(id) {
    return this.http.get(global.API_URL + '/api/groupscustomers/view/' + id);
  }

  editGroupsCustomers(customers, id) {
    return this.http.post( global.API_URL + '/api/groupscustomers/update/' + id, customers);
  }

  createUserGroupsCustomers(password, id) {
    const data: any = {};
    data.password = password;
    return this.http.post( global.API_URL + '/api/groupscustomers/createuser/' + id, data);
  }

  deleteGroupsCustomers(id) {
    return this.http.delete(global.API_URL + '/api/groupscustomers/delete/' + id);
  }

  getAllInvitations() {
    return this.http.get(global.API_URL + '/api/invitations');
  }

  getInvitation(id) {
    return this.http.get(global.API_URL + '/api/invitations/view/' + id);
  }

  reviewInvitation(id) {
    return this.http.post( global.API_URL + '/api/invitations/review/' + id, {});
  }

  deleteInvitation(id) {
    return this.http.delete(global.API_URL + '/api/invitations/delete/' + id);
  }

  getAllLanguages() {
    return this.http.get(global.API_URL + '/api/languages');
  }

  newLanguage(language) {
    return this.http.post( global.API_URL + '/api/languages/create', language);
  }

  getLanguage(id) {
    return this.http.get(global.API_URL + '/api/languages/view/' + id);
  }

  editLanguage(language, id) {
    return this.http.post( global.API_URL + '/api/languages/update/' + id, language);
  }

  deleteLanguage(id) {
    return this.http.delete(global.API_URL + '/api/languages/delete/' + id);
  }

  getPromoLanguage(id) {
    return this.http.get(global.API_URL + '/api/promolanguages/view/' + id);
  }

  newPromoLanguage(promo) {
    return this.http.post( global.API_URL + '/api/promolanguages/create', promo);
  }
  savePromoLanguage(promo) {
    return this.http.post( global.API_URL + '/api/promolanguages/save', promo);
  }
  editPromoLanguage(promo, id) {
    return this.http.post( global.API_URL + '/api/promolanguages/update/' + id, promo);
  }

  deletePromoLanguage(id) {
    return this.http.delete(global.API_URL + '/api/promolanguages/delete/' + id);
  }

  newPromoDay(day) {
    return this.http.post( global.API_URL + '/api/promodays/create', day);
  }
  editPromoDay(day, id) {
    return this.http.post( global.API_URL + '/api/promodays/update/' + id, day);
  }
  deletePromoDay(id) {
    return this.http.delete(global.API_URL + '/api/promodays/delete/' + id);
  }

  getConfiguration() {
    return this.http.get(global.API_URL + '/api/configuration/view');
  }

  editConfiguration(configuration) {
    return this.http.post( global.API_URL + '/api/configuration/update', configuration);
  }


  // UBICACIONES
  getAllComunidades() {
    return this.http.get(global.API_URL + '/api/comunidades');
  }
  getProvinciaByComunidad(id) {
    return this.http.get(global.API_URL + '/api/provinces/comunidad/' + id);
  }
  getCiudadesByProvincia(id){
    return this.http.get(global.API_URL + '/api/cities/' + id);
  }
  //CATEGORIAS

  getAllCategorias() {
    return this.http.get(global.API_URL + '/api/categories');
  }
  newCategoria(Categoria) {
    return this.http.post( global.API_URL + '/api/categories/create', Categoria);
  }
  getCategoria(id) {
    return this.http.get(global.API_URL + '/api/categories/view/' + id);
  }
  editCategoria(Categorias, id) {
    return this.http.post( global.API_URL + '/api/categories/update/' + id, Categorias);
  }
  deleteCategoria(id) {
    return this.http.delete(global.API_URL + '/api/categories/delete/' + id);
  }

  getCategoriaLanguage(id) {
    return this.http.get(global.API_URL + '/api/categorieslanguages/view/' + id);
  }

  newCategoriaLanguage(cat) {
    return this.http.post( global.API_URL + '/api/categorieslanguages/create', cat);
  }

  editCategoriaLanguage(cat, id) {
    return this.http.post( global.API_URL + '/api/categorieslanguages/update/' + id, cat);
  }

  deleteCategoriaLanguage(id) {
    return this.http.delete(global.API_URL + '/api/categorieslanguages/delete/' + id);
  }

  //SUBCATEGORIAS

  newSubcategoria(Categoria) {
    return this.http.post( global.API_URL + '/api/subcategories/create', Categoria);
  }
  deleteSubcategoria(id) {
    return this.http.delete(global.API_URL + '/api/subcategories/delete/' + id);
  }
  updateSubcategoria(Categorias, id) {
    return this.http.post( global.API_URL + '/api/subcategories/update/' + id, Categorias);
  }
  getSubcategoriasByCategoria(id) {
    return this.http.get(global.API_URL + '/api/subcategories/' + id);
  }
  getSubcategorias(id) {
    return this.http.get(global.API_URL + '/api/subcategories/view/' + id);
  }
  getSubcategoriaLanguage(id) {
    return this.http.get(global.API_URL + '/api/subcategorieslanguages/view/' + id);
  }

  newSubcategoriaLanguage(cat) {
    return this.http.post( global.API_URL + '/api/subcategorieslanguages/create', cat);
  }

  editSubcategoriaLanguage(cat, id) {
    return this.http.post( global.API_URL + '/api/subcategorieslanguages/update/' + id, cat);
  }

  deleteSubcategoriaLanguage(id) {
    return this.http.delete(global.API_URL + '/api/subcategorieslanguages/delete/' + id);
  }

  //PREFERENCIAS

  getAllPreferencias() {
    return this.http.get(global.API_URL + '/api/preferences');
  }
  newPreferencia(Preferencia) {
    return this.http.post( global.API_URL + '/api/preferences/create', Preferencia);
  }
  getPreferencia(id) {
    
    return this.http.get(global.API_URL + '/api/preferences/view/' + id);
  }
  editPreferencia(Preferencias, id) {
    return this.http.post( global.API_URL + '/api/preferences/update/' + id, Preferencias);
  }
  deletePreferencia(id) {
    return this.http.delete(global.API_URL + '/api/preferences/delete/' + id);
  }
  
  getPreferenceLanguage(id) {
    return this.http.get(global.API_URL + '/api/preferencelanguages/view/' + id);
  }
  newPreferenceLanguage(preference) {
    return this.http.post( global.API_URL + '/api/preferencelanguages/create', preference);
  }

  editPreferenceLanguage(preference, id) {
    return this.http.post( global.API_URL + '/api/preferencelanguages/update/' + id, preference);
  }

  deletePreferenceLanguage(id) {
    return this.http.delete(global.API_URL + '/api/preferencelanguages/delete/' + id);
  }

  // ESTADO SOLICITUDES

  getAllEstados() {
    return this.http.get(global.API_URL + '/api/estadosolicitudes');
  }
  newEstado(Estado) {
    return this.http.post( global.API_URL + '/api/estadosolicitudes/create', Estado);
  }
  getEstado(id) {
    
    return this.http.get(global.API_URL + '/api/estadosolicitudes/view/' + id);
  }
  editEstado(Estados, id) {
    return this.http.post( global.API_URL + '/api/estadosolicitudes/update/' + id, Estados);
  }
  deleteEstado(id) {
    return this.http.delete(global.API_URL + '/api/estadosolicitudes/delete/' + id);
  }

  //PROFILE

  getProfile() {
    const authenticationService = InjectorInstance.get<AuthenticationService>(AuthenticationService);
    const currentUser = authenticationService.currentUserValue;
    return this.http.get(global.API_URL + '/api/profiles/view/' + currentUser.id);
  }

  getMonthStats() {
    return this.http.get(global.API_URL + '/api/stats/bymonth');
  }

  getDayStats() {
    return this.http.get(global.API_URL + '/api/stats/byday');
  }

  getUserStats() {
    return this.http.get(global.API_URL + '/api/stats/users');
  }

  getAllSponsors() {
    return this.http.get(global.API_URL + '/api/sponsors');
  }

  newSponsor(sponsor) {
    return this.http.post( global.API_URL + '/api/sponsors/create', sponsor);
  }

  getSponsor(id) {
    return this.http.get(global.API_URL + '/api/locsponsorsals/view/' + id);
  }

  editSponsor(sponsor, id) {
    return this.http.post( global.API_URL + '/api/sponsors/update/' + id, sponsor);
  }

  deleteSponsor(id) {
    return this.http.delete(global.API_URL + '/api/sponsors/delete/' + id);
  }

  getAllCartacategorias() {
    return this.http.get(global.API_URL + '/api/menucategories');
  }
  getAllCartacategoriasByCarta(idcarta) {
    return this.http.get(global.API_URL + '/api/menucategories/bycarta/' + idcarta);
  }
  getAllCartacategoriasByLocal(idlocal) {
    return this.http.get(global.API_URL + '/api/menucategories/bylocal/' + idlocal);
  }
  copiarCategoriasIdioma(idlocal, infolang) {
    return this.http.post(global.API_URL + '/api/menucategories/copylangall/' + idlocal, infolang);
  }
  newCartacategoria(Categoria) {
    return this.http.post( global.API_URL + '/api/menucategories/create', Categoria);
  }
  getCartacategoria(id) {
    return this.http.get(global.API_URL + '/api/menucategories/view/' + id);
  }
  editCartacategoria(Categorias, id) {
    return this.http.post( global.API_URL + '/api/menucategories/update/' + id, Categorias);
  }
  renameCartaCategoria(categoria, id) {
    return this.http.post( global.API_URL + '/api/menucategories/rename/' + id, categoria);
  }
  deleteCartacategoria(id) {
    return this.http.delete(global.API_URL + '/api/menucategories/delete/' + id);
  }
  setPositionCategoria(categorias) {
    return this.http.post( global.API_URL + '/api/menucategories/setposition', categorias);
  }
  getCartacategoriaLanguage(id) {
    return this.http.get(global.API_URL + '/api/menucategorieslanguages/view/' + id);
  }

  newCartacategoriaLanguage(cat) {
    return this.http.post( global.API_URL + '/api/menucategorieslanguages/create', cat);
  }

  editCartacategoriaLanguage(cat, id) {
    return this.http.post( global.API_URL + '/api/menucategorieslanguages/update/' + id, cat);
  }

  deleteCartacategoriaLanguage(id) {
    return this.http.delete(global.API_URL + '/api/menucategorieslanguages/delete/' + id);
  }

  getAllAlergenos() {
    return this.http.get(global.API_URL + '/api/allergens');
  }
  newAlergeno(alergeno) {
    return this.http.post( global.API_URL + '/api/allergens/create', alergeno);
  }
  getAlergeno(id) {
    return this.http.get(global.API_URL + '/api/allergens/view/' + id);
  }
  editAlergeno(alergeno, id) {
    return this.http.post( global.API_URL + '/api/allergens/update/' + id, alergeno);
  }
  deleteAlergeno(id) {
    return this.http.delete(global.API_URL + '/api/allergens/delete/' + id);
  }

  getAlergenoLanguage(id) {
    return this.http.get(global.API_URL + '/api/allergenslanguage/view/' + id);
  }

  newAlergenoLanguage(ale) {
    return this.http.post( global.API_URL + '/api/allergenslanguage/create', ale);
  }

  editAlergenoLanguage(ale, id) {
    return this.http.post( global.API_URL + '/api/allergenslanguage/update/' + id, ale);
  }

  deleteAlergenoLanguage(id) {
    return this.http.delete(global.API_URL + '/api/allergenslanguage/delete/' + id);
  }

  getAllCartaproductos() {
    return this.http.get(global.API_URL + '/api/menuproducts');
  }
  getAllCartaproductosByCategory(id) {
    return this.http.get(global.API_URL + '/api/menuproducts/' + id);
  }
  newCartaproducto(Categoria) {
    return this.http.post( global.API_URL + '/api/menuproducts/create', Categoria);
  }
  getCartaproducto(id) {
    return this.http.get(global.API_URL + '/api/menuproducts/view/' + id);
  }
  editCartaproducto(Categorias, id) {
    return this.http.post( global.API_URL + '/api/menuproducts/update/' + id, Categorias);
  }
  editCartaproductoSelected(productos){
    return this.http.post( global.API_URL + '/api/menuproducts/updateselected', productos);
  }
  setPositionProducto(productos) {
    return this.http.post( global.API_URL + '/api/menuproducts/setposition', productos);
  }
  changeCategoryProducto(seccion){
    return this.http.post( global.API_URL + '/api/menuproducts/changecategory', seccion);
  }
  deleteCartaproducto(id) {
    return this.http.delete(global.API_URL + '/api/menuproducts/delete/' + id);
  }
  deleteCartaproductoSelected(productos){
    return this.http.post(global.API_URL + '/api/menuproducts/deleteselected', productos);
  }

  getCartaproductoLanguage(id) {
    return this.http.get(global.API_URL + '/api/menuproductslanguages/view/' + id);
  }
  getContentProductLang(infolang){
    return this.http.post(global.API_URL + '/api/menuproductslanguages/getproductlang', infolang);
  }

  newCartaproductoLanguage(cat) {
    return this.http.post( global.API_URL + '/api/menuproductslanguages/create', cat);
  }

  editCartaproductoLanguage(cat, id) {
    return this.http.post( global.API_URL + '/api/menuproductslanguages/update/' + id, cat);
  }

  deleteCartaproductoLanguage(id) {
    return this.http.delete(global.API_URL + '/api/menuproductslanguages/delete/' + id);
  }

  getAllQuestions() {
    return this.http.get(global.API_URL + '/api/questions/all');
  }

  getPanelQuestions() {
    return this.http.get(global.API_URL + '/api/questions/back');
  }

  newQuestion(question) {
    return this.http.post( global.API_URL + '/api/questions/create', question);
  }
  getQuestion(id) {
    return this.http.get(global.API_URL + '/api/questions/view/' + id);
  }
  editQuestion(question, id) {
    return this.http.post( global.API_URL + '/api/questions/update/' + id, question);
  }
  deleteQuestion(id) {
    return this.http.delete(global.API_URL + '/api/questions/delete/' + id);
  }
  getQuestionLanguage(id) {
    return this.http.get(global.API_URL + '/api/questionslanguages/view/' + id);
  }
  newQuestionLanguage(question) {
    return this.http.post( global.API_URL + '/api/questionslanguages/create', question);
  }

  editQuestionLanguage(question, id) {
    return this.http.post( global.API_URL + '/api/questionslanguages/update/' + id, question);
  }

  deleteQuestionLanguage(id) {
    return this.http.delete(global.API_URL + '/api/questionslanguages/delete/' + id);
  }

  getStatsBycustomer(id) {
    return this.http.get(global.API_URL + '/api/promos/getstatsbycustomer/' + id);
  }

  duplicatePromo(promo, data) {
    return this.http.post( global.API_URL + '/api/promos/duplicate/' + promo, data);
  }

  destacarPromo(promo) {
    return this.http.post( global.API_URL + '/api/promos/destacar/' + promo, null);
  }

  //Tipos PROMOCIONES

  getAllPromotypes() {
    return this.http.get(global.API_URL + '/api/promoTypes');
  }
  newPromotype(type) {
    return this.http.post( global.API_URL + '/api/promoTypes/create', type);
  }
  getPromotype(id) {
    return this.http.get(global.API_URL + '/api/promoTypes/view/' + id);
  }
  editPromotype(type, id) {
    return this.http.post( global.API_URL + '/api/promoTypes/update/' + id, type);
  }
  deletePromotype(id) {
    return this.http.delete(global.API_URL + '/api/promoTypes/delete/' + id);
  }

  getPromotypeLanguage(id) {
    return this.http.get(global.API_URL + '/api/promotypeslanguages/view/' + id);
  }

  newPromotypeLanguage(type) {
    return this.http.post( global.API_URL + '/api/promotypeslanguages/create', type);
  }

  editPromotypeLanguage(type, id) {
    return this.http.post( global.API_URL + '/api/promotypeslanguages/update/' + id, type);
  }

  deletePromotypeLanguage(id) {
    return this.http.delete(global.API_URL + '/api/promotypeslanguages/delete/' + id);
  }

  getAllCupones() {
    return this.http.get(global.API_URL + '/api/cupones');
  }

  getAllRutaCupones() {
    return this.http.get(global.API_URL + '/api/cupones/route');
  }

  newCupon(sponsor) {
    return this.http.post( global.API_URL + '/api/cupones/create', sponsor);
  }

  getCupon(id) {
    return this.http.get(global.API_URL + '/api/cupones/view/' + id);
  }

  editCupon(sponsor, id) {
    return this.http.post( global.API_URL + '/api/cupones/update/' + id, sponsor);
  }

  deleteCupon(id) {
    return this.http.delete(global.API_URL + '/api/cupones/delete/' + id);
  }

  getAllVideos() {
    return this.http.get(global.API_URL + '/api/videos');
  }

  newVideo(video) {
    return this.http.post( global.API_URL + '/api/videos/create', video);
  }

  getVideo(id) {
    return this.http.get(global.API_URL + '/api/videos/view/' + id);
  }

  editVideo(video, id) {
    return this.http.post( global.API_URL + '/api/videos/update/' + id, video);
  }

  deleteVideo(id) {
    return this.http.delete(global.API_URL + '/api/videos/delete/' + id);
  }

  setUserCoupon(id, formvalue) {
    return this.http.post( global.API_URL + '/api/users/setcoupon/' + id, formvalue);
  }

  getAllPushtypes() {
    return this.http.get(global.API_URL + '/api/pushtypes');
  }

  // CATEGORIAS AYUDA

  getAllCategoriasAyuda() {
    return this.http.get(global.API_URL + '/api/helpcategories');
  }
  newCategoriaAyuda(Categoria) {
    return this.http.post( global.API_URL + '/api/helpcategories/create', Categoria);
  }
  getCategoriaAyuda(id) {
    return this.http.get(global.API_URL + '/api/helpcategories/view/' + id);
  }
  editCategoriaAyuda(Categorias, id) {
    return this.http.post( global.API_URL + '/api/helpcategories/update/' + id, Categorias);
  }
  deleteCategoriaAyuda(id) {
    return this.http.delete(global.API_URL + '/api/helpcategories/delete/' + id);
  }

  // EVENTOS

  getAllEvents() {
    return this.http.get(global.API_URL + '/api/events');
  }

  getMeEvents(user) {
    return this.http.get(global.API_URL + '/api/events/me/' + user);
  }

  newEvent(event) {
    return this.http.post( global.API_URL + '/api/events/create', event);
  }

  getEvent(id) {
    return this.http.get(global.API_URL + '/api/events/view/' + id);
  }

  editEvent(event, id) {
    return this.http.post( global.API_URL + '/api/events/update/' + id, event);
  }

  deleteEvent(id) {
    return this.http.delete(global.API_URL + '/api/events/delete/' + id);
  }

  getInvitationsByEvent(id) {
    return this.http.get( global.API_URL + '/api/eventinvitations/byevent/' + id);
  }

  createInvitationsCSV(data) {
    return this.http.post( global.API_URL + '/api/eventinvitations/createcsv', data);
  }

  createInvitationsEmails(data) {
    return this.http.post( global.API_URL + '/api/eventinvitations/createmails', data);
  }

  confirmInvitation(data) {
    return this.http.post( global.API_URL + '/api/eventinvitations/confirm', data);
  }

  // TIPOS SOPORTE

  getAllSupportTypes() {
    return this.http.get(global.API_URL + '/api/supporttypes');
  }
  newSupportType(type) {
    return this.http.post( global.API_URL + '/api/supporttypes/create', type);
  }
  getSupportType(id) {
    
    return this.http.get(global.API_URL + '/api/supporttypes/view/' + id);
  }
  editSupportType(type, id) {
    return this.http.post( global.API_URL + '/api/supporttypes/update/' + id, type);
  }
  deleteSupportType(id) {
    return this.http.delete(global.API_URL + '/api/supporttypes/delete/' + id);
  }

    // SOPORTES

    getAllSupports() {
      return this.http.get(global.API_URL + '/api/support');
    }
    getAllSupportsByCustomer(id) {
      return this.http.get(global.API_URL + '/api/support/bycustomer/' + id);
    }
    newSupport(sup) {
      return this.http.post( global.API_URL + '/api/support/create', sup);
    }
    getSupport(id) {
      return this.http.get(global.API_URL + '/api/support/view/' + id);
    }
    editSupport(sup, id) {
      return this.http.post( global.API_URL + '/api/support/update/' + id, sup);
    }
    deleteSupport(id) {
      return this.http.delete(global.API_URL + '/api/support/delete/' + id);
    }

    // Administracion

    getAllAdminstrations() {
      return this.http.get(global.API_URL + '/api/administration');
    }

    getAdministrationByUser(id) {
      return this.http.get(global.API_URL + '/api/administration/user/' + id);
    }

    newAdminstration(admon) {
      
      
      return this.http.post( global.API_URL + '/api/administration/create', admon);
    }

    getAdminstration(id) {
      return this.http.get(global.API_URL + '/api/administration/view/' + id);
    }

    editAdminstration(admon, id) {
      return this.http.post( global.API_URL + '/api/administration/update/' + id, admon);
    }

    deleteAdminstration(id) {
      return this.http.delete(global.API_URL + '/api/administration/delete/' + id);
    }

    // Distritos
    getAllDistricts() {
      return this.http.get(global.API_URL + '/api/distritos');
    }
  
    getAllDistrictsByAdmin(admin: any) {
      return this.http.get(global.API_URL + '/api/distritos/byadmin/' + admin);
    }
  
    newDistrict(dis) {
      return this.http.post( global.API_URL + '/api/distritos/create', dis);
    }
  
    getDistrict(id) {
      return this.http.get(global.API_URL + '/api/distritos/view/' + id);
    }
  
    editDistrict(dis, id) {
      return this.http.post( global.API_URL + '/api/distritos/update/' + id, dis);
    }
  
    deleteDistrict(id) {
      return this.http.delete(global.API_URL + '/api/distritos/delete/' + id);
    }
  
    getAllBarriosByDistritos(dis: any) {
      return this.http.get(global.API_URL + '/api/barrios/bydistrito/' + dis);
    }
  
    newBarrio(barrio) {
      return this.http.post( global.API_URL + '/api/barrios/create', barrio);
    }
  
    getBarrio(id) {
      return this.http.get(global.API_URL + '/api/barrios/view/' + id);
    }
  
    editBarrio(barrio, id) {
      return this.http.post( global.API_URL + '/api/barrios/update/' + id, barrio);
    }
  
    deleteBarrio(id) {
      return this.http.delete(global.API_URL + '/api/barrios/delete/' + id);
    }
  
    //Puntos de información

  getAllPuntosInformacion() {
    return this.http.get(global.API_URL + '/api/puntosinformacion');
  }

  newPuntoInformacion(PuntoInformacion) {
    return this.http.post( global.API_URL + '/api/puntosinformacion/create', PuntoInformacion);
  }

  getPuntoInformacion(id) {
    return this.http.get(global.API_URL + '/api/puntosinformacion/view/' + id);
  }

  editPuntoInformacion(PuntosInformacion, id) {
    return this.http.post( global.API_URL + '/api/puntosinformacion/update/' + id, PuntosInformacion);
  }

  deletePuntoInformacion(id) {
    return this.http.delete(global.API_URL + '/api/puntosinformacion/delete/' + id);
  }

  //Caracteristicas

  getAllCaracteristicas() {
    return this.http.get(global.API_URL + '/api/caracteristicas');
  }

  newCaracteristica(Caracteristica) {
    return this.http.post( global.API_URL + '/api/caracteristicas/create', Caracteristica);
  }

  getCaracteristica(id) {
    return this.http.get(global.API_URL + '/api/caracteristicas/view/' + id);
  }

  getCaracteristicasByLocal(id) {
    return this.http.get(global.API_URL + '/api/caracteristicas/byLocal/' + id);
  }

  editCaracteristica(Caracteristicas, id) {
    return this.http.post( global.API_URL + '/api/caracteristicas/update/' + id, Caracteristicas);
  }
  
  deleteCaracteristica(id) {
    return this.http.delete(global.API_URL + '/api/caracteristicas/delete/' + id);
  }

  getCaracteristicaLanguage(id) {
    return this.http.get(global.API_URL + '/api/caracteristicaslanguage/view/' + id);
  }

  newCaracteristicaLanguage(pi) {
    return this.http.post( global.API_URL + '/api/caracteristicaslanguage/create', pi);
  }

  editCaracteristicaLanguage(pi, id) {
    return this.http.post( global.API_URL + '/api/caracteristicaslanguage/update/' + id, pi);
  }

  deleteCaracteristicaLanguage(id) {
    return this.http.delete(global.API_URL + '/api/caracteristicaslanguage/delete/' + id);
  }

  getAllRoutes() {
    return this.http.get(global.API_URL + '/api/routes');
  }

  getAllRoutesByManager(id) {
    return this.http.get(global.API_URL + '/api/routes/manager/' + id);
  }

  getAllRoutesByAdminPublica(id) {
    return this.http.get(global.API_URL + '/api/routes/adminpublica/' + id);
  }

  getAllRoutesByEditor(id) {
    return this.http.get(global.API_URL + '/api/routes/editor/' + id);
  }

  newRoute(route) {
    return this.http.post( global.API_URL + '/api/routes/create', route);
  }

  getRoute(id) {
    return this.http.get(global.API_URL + '/api/routes/view/' + id);
  }

  editRoute(route, id) {
    return this.http.post( global.API_URL + '/api/routes/update/' + id, route);
  }

  deleteRoute(id) {
    return this.http.delete(global.API_URL + '/api/routes/delete/' + id);
  }

  checkHasRouteValid(id) {
    return this.http.get(global.API_URL + '/api/routes/valid/' + id);
  }

  checkHasRouteValidByCustomer(id, localid) {
    return this.http.get(global.API_URL + '/api/routes/validcustomer/' + id + '/local/' + localid);
  }

  getAllTapasByRoute(id) {
    return this.http.get(global.API_URL + '/api/tapas/byroute/' + id);
  }

  getAllTapasByLocal(id) {
    return this.http.get(global.API_URL + '/api/tapas/bylocal/' + id);
  }

  newTapa(tapa) {
    return this.http.post( global.API_URL + '/api/tapas/create', tapa);
  }

  getTapa(id) {
    return this.http.get(global.API_URL + '/api/tapas/view/' + id);
  }

  editTapa(tapa, id) {
    return this.http.post( global.API_URL + '/api/tapas/update/' + id, tapa);
  }

  duplicateTapa(id) {
    return this.http.post(global.API_URL + '/api/tapas/duplicate/' + id, {});
  }

  deleteTapa(id) {
    return this.http.delete(global.API_URL + '/api/tapas/delete/' + id);
  }

  getRoutesStatsBycustomer(id) {
    return this.http.get(global.API_URL + '/api/routes/getstatsbycustomer/' + id);
  }

  getRoutesStatsByRoute(id) {
    return this.http.get(global.API_URL + '/api/routes/getstatsbyroute/' + id);
  }

  getAllManagers() {
    return this.http.get(global.API_URL + '/api/routemanagers');
  }

  newManager(manager) {
    return this.http.post( global.API_URL + '/api/routemanagers/create', manager);
  }

  getManager(id) {
    return this.http.get(global.API_URL + '/api/routemanagers/view/' + id);
  }

  getManagerByUser(id) {
    return this.http.get(global.API_URL + '/api/routemanagers/viewbyuser/' + id);
  }


  editManager(manager, id) {
    return this.http.post( global.API_URL + '/api/routemanagers/update/' + id, manager);
  }

  deleteManager(id) {
    return this.http.delete(global.API_URL + '/api/routemanagers/delete/' + id);
  }

  makeQrSvg(obj) {
    return this.http.post( global.API_URL + '/api/qr/makeqrSvg', obj);
  }

  makeQrPng(obj) {
    return this.http.post( global.API_URL + '/api/qr/makeqrPng', obj);
  }

  checkQr(obj) {
    return this.http.post( global.API_URL + '/api/qr/checkqr', obj);
  }

  getAllTareas() {
    return this.http.get(global.API_URL + '/api/tareas');
  }

  newTarea(tarea) {
    return this.http.post( global.API_URL + '/api/tareas/create', tarea);
  }

  getTarea(id) {
    return this.http.get(global.API_URL + '/api/tareas/view/' + id);
  }

  editTarea(tarea, id) {
    return this.http.post( global.API_URL + '/api/tareas/update/' + id, tarea);
  }

  deleteTarea(id) {
    return this.http.delete(global.API_URL + '/api/tareas/delete/' + id);
  }

  getAllTiposProyecto() {
    return this.http.get(global.API_URL + '/api/proyectostipos');
    
  }

  newError(tarea) {
    return this.http.post( global.API_URL + '/api/gestorerrores/create', tarea);
  }

  getErroresList() {
    return this.http.get(global.API_URL + '/api/gestorerrores');
  }

  getErroresCategorias() {
    return this.http.get(global.API_URL + '/api/gestorerrores/indexcategorias');
  }

  getErroresSubcategorias(categoria) {
    return this.http.get(global.API_URL + '/api/gestorerrores/indexsubcategorias/' + categoria);
  }

  getError(id) {
    return this.http.get(global.API_URL + '/api/gestorerrores/view/' + id);
  }

  editError(error, id) {
    return this.http.post( global.API_URL + '/api/gestorerrores/update/' + id, error);
  }

  deleteGestorErrores(id) {
    return this.http.delete(global.API_URL + '/api/gestorerrores/delete/' + id);
  }

  getAPPUsers() {
    return this.http.get(global.API_URL + '/api/users/getappusers');
  }

  getDemoUsers() {
    return this.http.get(global.API_URL + '/api/demousers');
  }

  searchDemoUsers(search, email) {
   
    const obj: any = {};
    obj.term = search;
    obj.email = email;
    return this.http.post(global.API_URL + '/api/demousers/search', obj);
  }

  newDemoUser(user) {
    return this.http.post( global.API_URL + '/api/demousers/create', user);
  }
  
  deleteDemoUser(id) {
    
    
    return this.http.delete( global.API_URL + '/api/demousers/delete/' + id);
  }

  getAllPatrocinadoresRutas(id) {
    return this.http.get(global.API_URL + '/api/patrocinadoresrutas/' + id);
  }

  newPatrocinadorRutas(tarea) {
    return this.http.post( global.API_URL + '/api/patrocinadoresrutas/create', tarea);
  }

  getPatrocinadorRutas(id) {
    return this.http.get(global.API_URL + '/api/patrocinadoresrutas/view/' + id);
  }

  editPatrocinadorRutas(tarea, id) {
    return this.http.post( global.API_URL + '/api/patrocinadoresrutas/update/' + id, tarea);
  }

  deletePatrocinadorRutas(id) {
    return this.http.delete(global.API_URL + '/api/patrocinadoresrutas/delete/' + id);
  }

  updateTapaLocal(tapa, local) {
    
    return this.http.get( global.API_URL + '/api/routes/updatelocal/' + tapa + '/local/' + local);
  }

  updatePrecioBySeccion(seccion, precio, productosExcepciones) {
    
    const obj: any = {};
    obj.seccion = seccion;
    obj.precio = precio;
    obj.productosExcepciones = productosExcepciones;
    return this.http.post( global.API_URL + '/api/menuproducts/setpreciobyseccion', obj);
  }

  updatePrecioDefectoBySeccion(seccion, precio) {

    const obj: any = {};
    obj.seccion = seccion;
    obj.precio = precio;
    return this.http.post( global.API_URL + '/api/menucategories/setpreciodefectobyseccion', obj);
  }

  getAllPages() {
    return this.http.get(global.API_URL + '/api/pages');
  }

  newPage(page) {
    return this.http.post( global.API_URL + '/api/pages/create', page);
  }

  getPage(id) {
    return this.http.get(global.API_URL + '/api/pages/view/' + id);
  }

  editPage(page, id) {
    return this.http.post( global.API_URL + '/api/pages/update/' + id, page);
  }

  deletePage(id) {
    return this.http.delete(global.API_URL + '/api/pages/delete/' + id);
  }

  // TRAMITACIONES

  getAllEncuestas() {
    return this.http.get(global.API_URL + '/api/encuestas');
  }

  getAllEncuestasByCoop($colegio: any) {
    return this.http.get(global.API_URL + '/api/encuestas/bycolegio/' + $colegio);
  }

  newEncuesta(encuesta: any) {
    return this.http.post( global.API_URL + '/api/encuestas/create', encuesta);
  }

  getEncuesta(id: any) {
    return this.http.get(global.API_URL + '/api/encuestas/view/' + id);
  }

  editEncuesta(encuesta: any, id: any) {
    return this.http.post( global.API_URL + '/api/encuestas/update/' + id, encuesta);
  }

  deleteEncuesta(id: any) {
    return this.http.delete(global.API_URL + '/api/encuestas/delete/' + id);
  }

  publishEncuesta(id: any) {
    return this.http.post(global.API_URL + '/api/encuestas/publish/' + id, {});
  }

  sendEncuestaReminder(id: any) {
    return this.http.post(global.API_URL + '/api/encuestas/sendreminder/' + id, {});
  }

  getAllEncuestasSeccion() {
    return this.http.get(global.API_URL + '/api/encuestasections');
  }

  newEncuestaSeccion(seccion: any) {
    return this.http.post( global.API_URL + '/api/encuestasections/create', seccion);
  }

  getEncuestaSeccion(id: any) {
    return this.http.get(global.API_URL + '/api/encuestasections/view/' + id);
  }

  editEncuestaSeccion(seccion: any, id: any) {
    return this.http.post( global.API_URL + '/api/encuestasections/update/' + id, seccion);
  }

  deleteEncuestaSeccion(id: any) {
    return this.http.delete(global.API_URL + '/api/encuestasections/delete/' + id);
  }

  getAllEncuestaCampos() {
    return this.http.get(global.API_URL + '/api/encuestafields');
  }

  newEncuestaCampo(campo: any) {
    return this.http.post( global.API_URL + '/api/encuestafields/create', campo);
  }

  getEncuestaCampo(id: any) {
    return this.http.get(global.API_URL + '/api/encuestafields/view/' + id);
  }

  editEncuestaCampo(campo: any, id: any) {
    return this.http.post( global.API_URL + '/api/encuestafields/update/' + id, campo);
  }

  deleteEncuestaCampo(id: any) {
    return this.http.delete(global.API_URL + '/api/encuestafields/delete/' + id);
  }

  getRegistroEncuesta(id: any) {
    return this.http.get(global.API_URL + '/api/regencuestas/view/' + id);
  }

  getRegistrosEncuesta(id: any) {
    return this.http.get(global.API_URL + '/api/regencuestas/bytram/' + id);
  }

  getRegistrosEncuestaRec() {
    return this.http.get(global.API_URL + '/api/regencuestas/received');
  }

  getRegistrosEncuestaRecByCoop(id: any) {
    return this.http.get(global.API_URL + '/api/regencuestas/receivedbycolegio/' + id);
  }
  getRegistrosEncuestaRecByCoopUnread(id: any) {
    return this.http.get(global.API_URL + '/api/regencuestas/receivedbycolegiounread/' + id);
  }
  registerReceptionEncuesta(id: any) {
    return this.http.post(global.API_URL + '/api/regencuestas/received/' + id, {});
  }

  registerEndEncuesta(id: any) {
    return this.http.post(global.API_URL + '/api/regencuestas/finalize/' + id, {});
  }

  newMessageEncuesta(message: any) {
    return this.http.post( global.API_URL + '/api/encuestamessages/create', message);
  }

  editMessageEncuesta(message: any, id: any) {
    return this.http.post( global.API_URL + '/api/encuestamessages/update/' + id, message);
  }

  readMessageEncuesta(id: any) {
    return this.http.post( global.API_URL + '/api/encuestamessages/read/' + id, {});
  }

  getAllEditores() {
    return this.http.get(global.API_URL + '/api/editores');
  }

  getEditoresByAdmin(id) {
    return this.http.get(global.API_URL + '/api/editores/admin/'+id);
  }

  getEditoresByGestor(id) {
    return this.http.get(global.API_URL + '/api/editores/gestor/'+id);
  }

  getEditoresByUser(id) {
    return this.http.get(global.API_URL + '/api/editores/user/'+id);
  }

  newEditor(editor) {
    return this.http.post( global.API_URL + '/api/editores/create', editor);
  }

  getEditor(id) {
    return this.http.get(global.API_URL + '/api/editores/view/' + id);
  }

  editEditor(manager, id) {
    return this.http.post( global.API_URL + '/api/editores/update/' + id, manager);
  }

  deleteEditor(id) {
    return this.http.delete(global.API_URL + '/api/editores/delete/' + id);
  }

  deleteTraduccion(promo_id, idioma_id) {
    return this.http.delete(global.API_URL + '/api/promolanguages/delete/' + promo_id + '/lang/' + idioma_id);
  }

  deleteTraduccionLocal(local_id, idioma_id) {
    return this.http.delete(global.API_URL + '/api/locallanguages/delete/' + local_id + '/lang/' + idioma_id);
  }

  deleteTraduccionRuta(ruta_id, idioma_id) {
    return this.http.delete(global.API_URL + '/api/rutalanguages/delete/' + ruta_id + '/lang/' + idioma_id);
  }

  deleteTraduccionTapa(tapa_id, idioma_id) {
    return this.http.delete(global.API_URL + '/api/tapalanguages/delete/' + tapa_id + '/lang/' + idioma_id);
  }

  getLocalLanguage(id) {
    return this.http.get(global.API_URL + '/api/locallanguages/view/' + id);
  }

  newLocalLanguage(local) {
    return this.http.post( global.API_URL + '/api/locallanguages/create', local);
  }
  saveLocalLanguage(local) {
    return this.http.post( global.API_URL + '/api/locallanguages/save', local);
  }
  editLocalLanguage(local, id) {
    return this.http.post( global.API_URL + '/api/locallanguages/update/' + id, local);
  }

  deleteLocalLanguage(id) {
    return this.http.delete(global.API_URL + '/api/locallanguages/delete/' + id);
  }

  getRutaLanguage(id) {
    return this.http.get(global.API_URL + '/api/rutalanguages/view/' + id);
  }

  newRutaLanguage(ruta) {
    return this.http.post( global.API_URL + '/api/rutalanguages/create', ruta);
  }
  saveRutaLanguage(ruta) {
    return this.http.post( global.API_URL + '/api/rutalanguages/save', ruta);
  }
  editRutaLanguage(ruta, id) {
    return this.http.post( global.API_URL + '/api/rutalanguages/update/' + id, ruta);
  }

  deleteRutaLanguage(id) {
    return this.http.delete(global.API_URL + '/api/rutalanguages/delete/' + id);
  }

  getTapaLanguage(id) {
    return this.http.get(global.API_URL + '/api/tapalanguages/view/' + id);
  }

  newTapaLanguage(ruta) {
    return this.http.post( global.API_URL + '/api/tapalanguages/create', ruta);
  }
  saveTapaLanguage(ruta) {
    return this.http.post( global.API_URL + '/api/tapalanguages/save', ruta);
  }
  editTapaLanguage(ruta, id) {
    return this.http.post( global.API_URL + '/api/tapalanguages/update/' + id, ruta);
  }

  deleteTapaLanguage(id) {
    return this.http.delete(global.API_URL + '/api/tapalanguages/delete/' + id);
  }

  getCartas(cliente_id) {
    return this.http.get(global.API_URL + '/api/cartas/'+ cliente_id);
  }

  newCarta(carta) {
    return this.http.post( global.API_URL + '/api/cartas/create', carta);
  }

  duplicateCarta(carta, data) {
    return this.http.post( global.API_URL + '/api/cartas/duplicate/' + carta, data);
  }
 
  editCarta(carta, id) {
    return this.http.post( global.API_URL + '/api/cartas/update/' + id, carta);
  }

  getCarta(id) {
    return this.http.get( global.API_URL + '/api/cartas/view/' + id);
  }

  deleteCarta(id) {
    return this.http.delete(global.API_URL + '/api/cartas/delete/' + id);
  }

  newPegatina(pegatina) {
    return this.http.post( global.API_URL + '/api/pegatinas/create', pegatina);
  }
  
  getAllPegatinas() {
    return this.http.get(global.API_URL + '/api/pegatinas/index');
  }

  getPegatina(id) {
    return this.http.get(global.API_URL + '/api/pegatinas/view/' + id);
  }

  editPegatina(id) {
    return this.http.get(global.API_URL + '/api/pegatinas/update/' + id);
  }

  //Caracteristicas

  getAllTextosLegales() {
    return this.http.get(global.API_URL + '/api/textoslegales');
  }

  newTextoLegal(textoLegal) {
    return this.http.post( global.API_URL + '/api/textoslegales/create', textoLegal);
  }

  getTextoLegal(id) {
    return this.http.get(global.API_URL + '/api/textoslegales/view/' + id);
  }

  editTextoLegal(textosLegales, id) {
    return this.http.post( global.API_URL + '/api/textoslegales/update/' + id, textosLegales);
  }
  
  deleteTextoLegal(id) {
    return this.http.delete(global.API_URL + '/api/textoslegales/delete/' + id);
  }

  getTextoLegalLanguage(id) {
    return this.http.get(global.API_URL + '/api/textoslegaleslanguage/view/' + id);
  }

  newTextoLegalLanguage(pi) {
    return this.http.post( global.API_URL + '/api/textoslegaleslanguage/create', pi);
  }

  editTextoLegalLanguage(pi, id) {
    return this.http.post( global.API_URL + '/api/textoslegaleslanguage/update/' + id, pi);
  }

  deleteTextoLegalLanguage(id) {
    return this.http.delete(global.API_URL + '/api/textoslegaleslanguage/delete/' + id);
  }

}



